module.exports = __webpack_public_path__ + "img/Sakralbau_5_b.0cd6531b.jpg";